import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import {
	type LWApiPublicAssetControlPanelCredentialsUsernameAndPasswordParamsRaw,
	type LWApiPublicAssetControlPanelCredentialsUsernameAndPasswordResultRaw,
} from '@liquidweb-dev/club-sauce/public/asset/controlPanel/credentials/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ASSET_CONTROL_PANEL_CREDENTIALS_USERNAME_PASSWORD =
	'/asset/controlPanel/credentials/usernameAndPassword';

const useUsernameAndPassword = (
	params: LWApiPublicAssetControlPanelCredentialsUsernameAndPasswordParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicAssetControlPanelCredentialsUsernameAndPasswordResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ASSET_CONTROL_PANEL_CREDENTIALS_USERNAME_PASSWORD, params],
		queryFn: () =>
			api.asset.controlPanel.credentials.apiRaw.usernameAndPassword(params),
		...options,
	});

export default useUsernameAndPassword;
